import React, { useEffect } from 'react';
import { MenuTab } from 'eshops-components-library';
import PropTypes from 'prop-types';

import {
  useRenderContext,
  useRenderDispatcher,
} from '../../pages/home/context';
import ClientService from '../../../services/client';

const MenuTabWrapper = (props) => {
  const renderActions = useRenderDispatcher();
  const { apiBasePath, device, marketplaceInfo: { isWebview } } = useRenderContext();
  const request = new ClientService(apiBasePath);

  const refreshPage = async ({ domain, subdomain, id, name, url: urlFallback, fragments }, ignoreHistory = false) => {
    if (device === 'desktop') {
      window.location.href = `${urlFallback}${fragments}`;
      return domain;
    }

    const response = await request.get(
      '/refresh',
      {
        params: {
          url: `${domain}${subdomain}`,
          selectorId: name.toLowerCase(),
          storefrontId: id.split('-')[0],
          device,
        },
      },
      5000,
    );

    if (!response?.data?.appearance) {
      window.location.href = `${urlFallback}${fragments}`;
      return null;
    }

    renderActions.updateLayout(response.data.appearance, {
      sender: 'home',
    });

    if (!isWebview) {
      const currentPath = window.location.pathname;
      if (!ignoreHistory) {
        window.history.replaceState({ path: currentPath }, '', `${currentPath}${fragments}`);
        window.history.pushState({ path: subdomain }, '', `${subdomain}${fragments}`);
      }
    }

    return response;
  };

  useEffect(() => {
    const { tabs } = props;

    const handlePopState = (event) => {
      if (isWebview) return null;
      const path = event.state?.path || window.location.pathname;
      if (!path || tabs.length === 0) return window.location.reload();
      const tabToRefresh = props?.tabs?.find((tab) => path.includes(tab.subdomain));
      return refreshPage(tabToRefresh, true);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [renderActions, props]);

  return <MenuTab deviceType={device} {...props} onChange={refreshPage} />;
};

MenuTabWrapper.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
};

export default MenuTabWrapper;
